import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import './BlogsFAQ.scss';
import faqImage from '../assets/unnamed.jpg';

const BlogsFAQ = () => {
    const faqsEnglish = [
        {
            question: "How often should I visit a dentist?",
            answer: "It is recommended to visit your dentist every six months for a check-up and cleaning. Regular visits help detect problems early and prevent major dental issues."
        },
        {
            question: "Why do my gums bleed while brushing?",
            answer: "Bleeding gums are a sign of gum inflammation or infection (gingivitis). Use a soft-bristled brush and maintain proper oral hygiene. If bleeding persists, consult your dentist."
        },
        {
            question: "What causes bad breath?",
            answer: "Poor oral hygiene, gum disease, dry mouth, or certain foods can cause bad breath. Brushing, flossing, and tongue cleaning daily can help prevent it."
        },
        {
            question: "Are electric toothbrushes better than manual ones?",
            answer: "Both can be effective if used properly, but electric toothbrushes can help people who have difficulty brushing thoroughly, especially children and seniors."
        },
        {
            question: "What should I do if a tooth gets knocked out?",
            answer: "Pick it up by the crown (not the root), rinse gently, place it in milk, and reach your dentist immediately. Early action can save the tooth."
        },
        {
            question: "Is flossing really necessary?",
            answer: "Yes! Flossing removes food particles and plaque between teeth that a brush can't reach, preventing cavities and gum disease."
        },
        {
            question: "How can I whiten my teeth safely?",
            answer: "Professional whitening by a dentist is safe and effective. Avoid over-the-counter kits without supervision as they may damage enamel."
        },
        {
            question: "What are dental sealants?",
            answer: "Sealants are thin coatings applied on back teeth to prevent cavities — especially useful for children and teenagers."
        },
        {
            question: "Are dental X-rays safe?",
            answer: "Yes. Dental X-rays use very low radiation and are safe even for children. They help detect hidden decay and bone problems."
        },
        {
            question: "What is a root canal treatment?",
            answer: "It's a procedure to remove infection from the inner part of a tooth and save it from extraction. Modern root canals are nearly painless and highly effective."
        },
        {
            question: "What are dental implants and who needs them?",
            answer: "Implants are artificial tooth roots placed in the jaw to replace missing teeth. They are ideal for people with lost or severely damaged teeth."
        },
        {
            question: "How can I protect my teeth from cavities?",
            answer: "Brush twice daily with fluoride toothpaste, floss regularly, limit sugary snacks, and drink enough water."
        },
        {
            question: "What should I eat for strong teeth?",
            answer: "Calcium-rich foods like milk, cheese, leafy greens, and vitamin D help strengthen teeth and bones. Avoid acidic drinks and excessive sugar."
        },
        {
            question: "What should parents know about children's teeth?",
            answer: "Start cleaning your baby's gums even before teeth appear. Schedule the first dental visit by age 1. Avoid bottle-feeding at bedtime to prevent tooth decay."
        },
        {
            question: "Are braces only for children?",
            answer: "No, adults can also get braces or clear aligners to correct misaligned teeth and improve smile aesthetics at any age."
        },
        {
            question: "How can I relieve tooth sensitivity?",
            answer: "Use a toothpaste for sensitive teeth and avoid very hot or cold foods. Persistent sensitivity may need professional treatment."
        },
        {
            question: "Is it normal to have wisdom tooth pain?",
            answer: "Some discomfort is normal when wisdom teeth erupt. However, swelling, pain, or infection needs dental attention — extraction may be required."
        },
        {
            question: "How can I keep dentures clean?",
            answer: "Brush dentures daily with a soft brush, rinse after meals, and soak them overnight in a denture-cleaning solution."
        },
        {
            question: "Can oral health affect general health?",
            answer: "Yes, poor oral hygiene is linked to diabetes, heart disease, and respiratory problems. Maintaining good oral health benefits your overall body."
        },
        {
            question: "How can I maintain lifelong dental health?",
            answer: "Follow the \"2-2-2 Rule\" — Brush twice a day for 2 minutes, visit your dentist twice a year, and maintain a balanced diet for healthy teeth and gums."
        }
    ];

    const faqsHindi = [
        {
            question: "दंत चिकित्सक के पास कितनी बार जाना चाहिए?",
            answer: "हर छह महीने में एक बार जांच और सफाई करवाना चाहिए ताकि समस्याओं का समय पर पता चले।"
        },
        {
            question: "ब्रश करते समय मसूड़ों से खून क्यों आता है?",
            answer: "यह मसूड़ों में सूजन या संक्रमण का संकेत है। मुलायम ब्रश का प्रयोग करें और अगर खून आता रहे तो डॉक्टर से सलाह लें।"
        },
        {
            question: "मुंह की बदबू का कारण क्या है?",
            answer: "गलत सफाई, मसूड़ों की बीमारी या सूखा मुंह इसके कारण हो सकते हैं। रोज ब्रश और फ्लॉस करने से बचाव होता है।"
        },
        {
            question: "क्या इलेक्ट्रिक टूथब्रश बेहतर होता है?",
            answer: "दोनों ठीक हैं, लेकिन इलेक्ट्रिक ब्रश से दांतों की सफाई बेहतर होती है, खासकर बच्चों और बुजुर्गों के लिए।"
        },
        {
            question: "अगर दांत टूट जाए तो क्या करें?",
            answer: "दांत को जड़ से नहीं, ऊपर से उठाएं, साफ करें, दूध में रखें और तुरंत डॉक्टर के पास जाएं।"
        },
        {
            question: "क्या फ्लॉसिंग जरूरी है?",
            answer: "हाँ, यह दांतों के बीच की गंदगी हटाता है और कैविटी से बचाव करता है।"
        },
        {
            question: "दांत सफेद कैसे करें?",
            answer: "डेंटल क्लिनिक में किया गया व्हाइटनिंग सुरक्षित होता है। घरेलू किट्स से परहेज करें।"
        },
        {
            question: "डेंटल सीलेंट क्या होता है?",
            answer: "यह एक पतली परत होती है जो दांतों पर लगाई जाती है ताकि बच्चों को कैविटी से बचाया जा सके।"
        },
        {
            question: "क्या डेंटल एक्स-रे सुरक्षित है?",
            answer: "हाँ, डेंटल एक्स-रे में बहुत कम रेडिएशन होता है और यह पूरी तरह सुरक्षित है।"
        },
        {
            question: "रूट कैनाल क्या होता है?",
            answer: "संक्रमित दांत को बचाने के लिए उसकी जड़ से संक्रमण हटाने की प्रक्रिया रूट कैनाल कहलाती है। यह दर्दरहित होती है।"
        },
        {
            question: "डेंटल इम्प्लांट क्या है?",
            answer: "यह कृत्रिम दांत की जड़ है जो खोए हुए दांत को स्थायी रूप से बदल देती है।"
        },
        {
            question: "कैविटी से बचाव कैसे करें?",
            answer: "दिन में दो बार ब्रश करें, फ्लॉस करें, मीठे खाद्य पदार्थ कम खाएं और नियमित जांच करवाएं।"
        },
        {
            question: "दांत मजबूत करने के लिए क्या खाएं?",
            answer: "दूध, पनीर, हरी सब्जियां और विटामिन D वाले खाद्य पदार्थ दांतों को मजबूत बनाते हैं।"
        },
        {
            question: "बच्चों की दंत देखभाल कैसे करें?",
            answer: "बच्चे के दांत आने से पहले ही मसूड़े साफ करें और एक साल की उम्र तक डॉक्टर को दिखाएं।"
        },
        {
            question: "क्या ब्रेसिज़ केवल बच्चों के लिए होते हैं?",
            answer: "नहीं, वयस्क भी ब्रेसिज़ या एलाइनर लगवा सकते हैं।"
        },
        {
            question: "दांतों की संवेदनशीलता कैसे कम करें?",
            answer: "सेंसिटिव टूथपेस्ट का प्रयोग करें और बहुत ठंडा या गर्म भोजन न लें।"
        },
        {
            question: "क्या अक्लदाढ़ का दर्द सामान्य है?",
            answer: "कुछ दर्द सामान्य होता है, लेकिन अगर सूजन या संक्रमण हो तो डॉक्टर को दिखाएं।"
        },
        {
            question: "डेंचर कैसे साफ करें?",
            answer: "हर दिन ब्रश करें, खाने के बाद कुल्ला करें और रात में डेंचर सॉल्यूशन में रखें।"
        },
        {
            question: "क्या दांतों का स्वास्थ्य शरीर पर असर डालता है?",
            answer: "हाँ, खराब दांत और मसूड़ों का स्वास्थ्य से हृदय रोग, मधुमेह जैसी बीमारियाँ हो सकती हैं।"
        },
        {
            question: "जीवनभर दांत स्वस्थ कैसे रखें?",
            answer: "\"2-2-2 नियम\" अपनाएं — दिन में दो बार, दो मिनट तक ब्रश करें और साल में दो बार दांतों के डॉक्टर को दिखाएं।"
        }
    ];

    return (
        <>
            <Navbar />
            
            <section className='blogs-faq-section'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-header">
                                <h1>Top 20 Dental Health FAQs – Your Complete Oral Care Guide</h1>
                                <p className="subtitle">FAQ'S DENTAL HEALTH RELATED</p>
                                <p className="intro-text">
                                    Good dental health is essential not only for a confident smile but also for overall well-being. 
                                    Here are the 20 most frequently asked questions that help patients understand dental care better and make informed decisions.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="faq-image-container">
                                <img src={faqImage} alt="Dental Health FAQs" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-8">
                            <div className="faq-intro">
                                <h2>Understanding Your Dental Health</h2>
                                <p>
                                    At TRUECARE Dental & Implant Center, we believe that informed patients make better decisions about their oral health. 
                                    This comprehensive FAQ guide covers the most common questions we receive from our patients.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-12">
                            <h2 className="section-title">English FAQs</h2>
                        </div>
                    </div>

                    <div className="row">
                        {faqsEnglish.map((faq, index) => (
                            <div key={index} className="col-lg-6 mb-4">
                                <div className="faq-card">
                                    <div className="faq-number">{index + 1}</div>
                                    <h3 className="faq-question">{faq.question}</h3>
                                    <p className="faq-answer">{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="row mt-5">
                        <div className="col-12">
                            <h2 className="section-title hindi-title">डेंटल स्वास्थ्य के शीर्ष 20 सामान्य प्रश्न</h2>
                            <p className="hindi-intro">
                                अच्छे दांत केवल सुंदर मुस्कान के लिए नहीं, बल्कि पूरे शरीर के स्वास्थ्य के लिए भी जरूरी हैं। 
                                नीचे 20 ऐसे प्रश्न दिए गए हैं जो हर व्यक्ति के लिए उपयोगी हैं।
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        {faqsHindi.map((faq, index) => (
                            <div key={index} className="col-lg-6 mb-4">
                                <div className="faq-card hindi-faq">
                                    <div className="faq-number">{index + 1}</div>
                                    <h3 className="faq-question">{faq.question}</h3>
                                    <p className="faq-answer">{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="row mt-5">
                        <div className="col-12">
                            <div className="disclaimer-section">
                                <h3>Disclaimer</h3>
                                <p>
                                    The above FAQs are for general patient awareness. They do not replace a personalized consultation with a qualified dentist.
                                    <br />
                                    <strong>Always consult a dental professional for diagnosis and treatment.</strong>
                                </p>
                                <p className="hindi-disclaimer">
                                    उपरोक्त जानकारी केवल सामान्य जागरूकता के लिए है। किसी भी प्रकार की समस्या या इलाज के लिए अपने योग्य दंत चिकित्सक से परामर्श अवश्य लें।
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <div className="contact-cta">
                                <h3>Have More Questions?</h3>
                                <p>Contact TRUECARE Dental & Implant Center for personalized dental care</p>
                                <a href="tel:6395947006" className="cta-button">
                                    📞 Call Now: 6395947006
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default BlogsFAQ;
